import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAllAppliedFacetItemUids } from 'app/products/productsReducer';
import AppliedFacetItem from './appliedFacetItem';

function AppliedFacetsList({ facetItemUids, sizeIndicatorDisplayCallback }) {
  useEffect(() => {
    const hasActiveClass = document.getElementById('size-facet-navigation')?.classList.contains('active');
    const hasSizeFacetApplied = !!facetItemUids.filter(uid => uid.includes('size:')).length;
    sizeIndicatorDisplayCallback(hasSizeFacetApplied || hasActiveClass);
  }, [facetItemUids, sizeIndicatorDisplayCallback]);

  return (
    facetItemUids.length > 0 && (
      <div>
        <ul className="applied-facets-list__list">
          {facetItemUids.map(uid => (
            <AppliedFacetItem uid={uid} key={uid} />
          ))}
        </ul>
      </div>
    )
  );
}

AppliedFacetsList.defaultProps = {
  sizeIndicatorDisplayCallback: () => null,
};

AppliedFacetsList.propTypes = {
  facetItemUids: PropTypes.arrayOf(PropTypes.string).isRequired,
  sizeIndicatorDisplayCallback: PropTypes.func,
};

const mapStateToProps = state => ({
  facetItemUids: getAllAppliedFacetItemUids(state),
});

export default connect(mapStateToProps)(AppliedFacetsList);
